import { Component, OnInit, ChangeDetectionStrategy , inject} from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { PrimeNGConfig } from 'primeng/api';
import Swal from 'sweetalert2';
import { CombustiblesService } from '@/app/services/combustibles.service';
import { CompaniaService } from '@/app/services/compania.service';
import { FamiliaequipoService } from '@/app/services/familiaequipo.service';
import { EquiposService } from '@/app/services/equipos.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { CentroCostosService } from '@/app/services/centro-costos.service';
import { CompaniaLmService } from '@/app/services/compania-lm.service';
import { CuentasLmService } from '@/app/services/cuentas-lm.service';
import { SubcuentasService } from '@/app/services/subcuentas.service';
import { UbicacionesLmService } from '@/app/services/ubicaciones-lm.service';
import { UnidadNegocioService } from '@/app/services/unidad-negocio.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { TokenReaderService } from '@/app/services/security/token-reader.service';
import { ActivosService } from '@/app/services/activos.service';
import { EstacionesService } from '@/app/services/estaciones.service';
import { EstatusService } from '@/app/services/estatus.service';

@Component({
    selector: 'app-crear-activo',
    templateUrl: './crear-activo.component.html',
    styleUrls: ['./crear-activo.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CrearActivoComponent implements OnInit {
  private spinner = inject(NgxSpinnerService);

  hasFinished: boolean = false;

  cuentaContableDebito: string = " ?? - ?? - ?????? - ???? - 0000 - 0000 - 00 ";

  activoRQ = {
    activo: '',
    descripcion: '',
    modelo: '',
    planta: '',
    estado: '',
    anio: '',
    tipo: '', //catalog
    idEstatus: '',
    idFamiliaEquipo: null,//catalogo
    idCondicionEquipo: null,
    capacidad: '',
    idCompaniaLM: '',
    idUnidadNegocioLM: '1',
    idCentroCostosLM: '',
    idUbicacionLM: '',
    idCuentaLM: '',
    idSubCuentaLM: '1',
    idEquipoLM: 1,
    idIntercompaniaLM: 1,
    compania: '', //catalogo
    ubicacion: '', //catalogo
    tipoCombustible: '', //catalogo
    marca: '',
    numeroActivoCORE: '', 
    numeroMotor: '',
    numeroSerie: '',
    factura: '',
    fechaFactura: null,
    valorFactura: '',
    costoTotal: '',
    costoAcumuladoAnual: '',
    valorActual: '',
    creadoPor: '',
  }

  //catalogos
  combustiblesCatalog: any[] =[];
  companiasCatalog: any[] =[];
  familiasCatalog: any[] =[];
  tiposEquiposCatalog: any[] = [];
  condicionesEquiposCatalog: any[] = [];
  estacionesCatalog: any[] = [];
  estatusCatalog: any[] = [];

  //cuentaLM
  companiasLM: any[] = [];
  unidadNegocio: any[] = [];
  centroCostos: any[] = [];
  ubicacionLM: any[] = [];
  cuentasLM: any[] = [];
  subCuentasLM: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<CrearActivoComponent>,
    private config: PrimeNGConfig,
    private combustiblesService: CombustiblesService,
    private companiaService: CompaniaService,
    private familiaEquipoService: FamiliaequipoService,
    private equiposService: EquiposService,
    private activosService: ActivosService,
    private estacionesService: EstacionesService,
    private toastr: ToastrService,
    private router: Router,
    private centroCostosService: CentroCostosService,
    private companiaLMService: CompaniaLmService,
    private cuentasLMService: CuentasLmService,
    private subCuentasService: SubcuentasService,
    private ubicacionesLMService: UbicacionesLmService,
    private unidadNegocioService: UnidadNegocioService,
    private userTokenReaderService: TokenReaderService,
    private estatusService: EstatusService,
  ){
   this.obtenerTipoEquipo(); 
   this.obtenerCondicionEquipo();
   this.getFamiliaEquipo();
   this.obtenerCombustibles();
   this.obtenerCompania();
   this.obtenerEstaciones();
   this.getEstatus();
   //
   this.getCentroCostosLM();
   this.getCompaniaLM();
   this.getCuentaLM();
   this.getSubCuentaLM();
   this.getUnidadNegocioLM();
   this.getUbicacionLM();
  }
  ngOnInit(): void {
    this.config.setTranslation ({
      firstDayOfWeek: 1,
      dayNames: ["domingo", "lunes", "martes", "miércoles", "jueves", "viernes", "sábado"],
      dayNamesShort: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
      dayNamesMin: ["D", "L", "M", "M", "J", "V", "S"],
      monthNames: ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"],
      monthNamesShort: ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"],
      today: 'Hoy',
      clear: 'Borrar'
    });
  }

  clearFecha(event: any){
    this.activoRQ.fechaFactura = null;
  }

  formSubmit(form: NgForm){
    if(form.valid){
      Swal.fire({
        title: 'Confirmar',
        text: "¿Deseas crear un nuevo activo?",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#1c869e ',
        cancelButtonColor:  '#999999',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Regresar',
        allowOutsideClick: true,
        reverseButtons: true
      }).then((result) => { 
        if(result.value){
          this.insertActivo();
        }
      });
    }
  }

  insertActivo(){
    this.spinner.show();
    this.activoRQ.creadoPor = this.userTokenReaderService.getUserData().idUsuario;
    this.activoRQ.idIntercompaniaLM = 1;
    this.activoRQ.idEquipoLM = 1;
    console.log(this.activoRQ)
    this.activosService.insertActivo(this.activoRQ).subscribe({
      next: (data: any)=>{
        this.spinner.hide();
        Swal.fire(
          'Éxito',
          'Activo registrado correctamente.',
          'success'
        ).then(result=>{
          this.hasFinished = true;
          this.onClose();
        });
      },
      error: (err) =>{
        this.spinner.hide();
        if (err.status == 401) {
          this.toastr.error(
            'Tu sesión expiró o no tienes permiso para ver esta página.',
            'Acceso no autorizado'
          );
          this.router.navigate(['/login']);
        } else {
          if (err.error) {
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo.Error, 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  onClose(){
    if(!this.hasFinished){
      Swal.fire({
        title: 'Alerta',
        text: "No se ha registrado la carga. ¿Seguro que deseas salir?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#999999',
        cancelButtonColor:  '#1c869e',
        confirmButtonText: 'Salir',
        cancelButtonText: 'No salir',
        allowOutsideClick: false,
        reverseButtons: false
      }).then((result) => {
        if(result.value){
          this.dialogRef.close({updateList: false});
        }
      });
    } else{
      this.dialogRef.close({updateList: true});
    }
  }

  //#region listas
  //catalogos
  obtenerTipoEquipo(){
    this.equiposService.obtenerTipoEquipo().subscribe({       
      next: (data: any) => {
        if(data != null && data.TipoEquipos != null){
           this.tiposEquiposCatalog = data.TipoEquipos.filter( (i: any) => i['Nombre'] != '').map( (i: any) => {return {'label': i.Nombre, 'value': i.idTipoEquipo} } );    
        }
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.tiposEquiposCatalog = [];
          this.activoRQ.tipo = ""; 
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  obtenerCondicionEquipo(){
    this.equiposService.obtenerCondicionEquipo().subscribe({       
      next: (data: any) => {
        if(data != null && data.CondicionEquipo != null){
           this.condicionesEquiposCatalog = data.CondicionEquipo.filter( (i: any) => i['Nombre'] != '').map( (i: any) => {return {'label': i.Nombre, 'value': i.idCondicionEquipo} } );    
        }
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.condicionesEquiposCatalog = [];
          this.activoRQ.idCondicionEquipo = null; 
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  getFamiliaEquipo(){
    this.familiaEquipoService.getFamiliaEquipo().subscribe({       
      next: (data: any) => {
        if(data != null && data.Familia != null){
           this.familiasCatalog = data.Familia.filter( (i: any) => i['valor'] != '').map( (i: any) => {return {'label': i.valor, 'value': i.idFamiliaEquipo} } );    
        }
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.familiasCatalog = [];
          this.activoRQ.idFamiliaEquipo = null; 
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }
  obtenerCombustibles(){
    this.combustiblesService.obtenerCombustibles().subscribe({       
      next: (data: any) => {
        if(data != null && data.Combustible != null){
           this.combustiblesCatalog = data.Combustible.filter( (i: any) => i['tipo'] != '').map( (i: any) => {return {'label': i.tipo, 'value': i.idCombustible} } );    
        }
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.combustiblesCatalog = [];
          this.activoRQ.tipoCombustible = ""; 
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  obtenerCompania(){
    this.companiaService.obtenerCompania().subscribe({       
      next: (data: any) => {
        if(data != null && data.Companias != null){
           this.companiasCatalog = data.Companias.filter( (i: any) => i['clave'] != '').map( (i: any) => {return {'label': i.clave, 'value': i.idCompania} } );    
        }
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.companiasCatalog = [];
          this.activoRQ.compania = ""; 
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  obtenerEstaciones(){
    this.estacionesService.obtenerEstaciones().subscribe({       
      next: (data: any) => {
        if(data != null && data.Estaciones != null){
          this.estacionesCatalog = data.Estaciones.filter( (i: any) => i['IATA'] != '').map( (i: any) => {return {'label': i.IATA, 'value': i.idEstacion} } );    
        }
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.estacionesCatalog = [];
          this.activoRQ.ubicacion = ""; 
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  getEstatus(){
    this.estatusService.getEstatus().subscribe({       
      next: (data: any) => {
        if(data != null && data.Estatus != null){
          this.estatusCatalog = data.Estatus.filter( (i: any) => i['estatus'] != '').map( (i: any) => {return {'label': i.estatus, 'value': i.idEstatus} } ); 
          
          let selectedDefault = this.estatusCatalog.find(x => x['label'].toUpperCase() === 'OPERATING')['value'];
          if(selectedDefault != null)
            this.activoRQ.idEstatus = selectedDefault;
        }
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.estatusCatalog = [];
          this.activoRQ.idEstatus = ""; 
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  //CUENTA LM
  getCentroCostosLM(){
    this.centroCostosService.getCentroCostosLM().subscribe({       
      next: (data: any) => {
        if(data != null && data.CentroCostosLM != null){
           this.centroCostos = data.CentroCostosLM.filter( (i: any) => i['Descripcion'] != '' && i['Activo']).map( (i: any) => {return {'label': i.Descripcion, 'description': i.Valor, 'value': i.IdCentroCostosLM} } ); 
        }
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.centroCostos = [];
          this.activoRQ.idCentroCostosLM = ""; 
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  getCompaniaLM(){
    this.companiaLMService.getCompaniaLM().subscribe({       
      next: (data: any) => {
        if(data != null && data.CompaniaLM != null){
           this.companiasLM = data.CompaniaLM.filter( (i: any) => i['Descripcion'] != '').map( (i: any) => {return {'label': i.Descripcion, 'description': i.Valor, 'value': i.idCompaniaLM} } );    
        }
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.companiasLM = [];
          this.activoRQ.idCompaniaLM = ""; 
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  getCuentaLM(){
    this.cuentasLMService.getCuentaLM().subscribe({       
      next: (data: any) => {
        if(data != null && data.Cuentalm != null){
           this.cuentasLM = data.Cuentalm.filter( (i: any) => i['Descripcion'] != '' && i['Activo']).map( (i: any) => {return {'label': i.Descripcion, 'description': i.Valor,'value': i.idCuentaLM} } );
        }
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.cuentasLM = [];
          this.activoRQ.idCuentaLM = ""; 
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  getSubCuentaLM(){
    this.subCuentasService.getSubCuentaLM().subscribe({       
      next: (data: any) => {
        if(data != null && data.Subcuentalm != null){
           this.subCuentasLM = data.Subcuentalm.filter( (i: any) => i['Descripcion'] != '' && i['Activo']).map( (i: any) => {return {'label': i.Descripcion,'description': i.Valor, 'value': i.idSubCuentaLM} } );    
        }
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.subCuentasLM = [];
          this.activoRQ.idSubCuentaLM = ""; 
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  getUbicacionLM(){
    this.ubicacionesLMService.getUbicacionLM().subscribe({       
      next: (data: any) => {
        if(data != null && data.UbicacionLM != null){
           this.ubicacionLM = data.UbicacionLM.filter( (i: any) => i['Descripcion'] != '' && i['Activo']).map( (i: any) => {return {'label': i.Descripcion, 'description': i.Valor, 'value': i.IdUbicacionLM} } );    
        }
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.ubicacionLM = [];
          this.activoRQ.idUbicacionLM = ""; 
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  getUnidadNegocioLM(){
    this.unidadNegocioService.getUnidadNegocioLM().subscribe({       
      next: (data: any) => {
        if(data != null && data.CompaniaLM != null){
           this.unidadNegocio = data.CompaniaLM.filter( (i: any) => i['Descripcion'] != '').map( (i: any) => {return {'label': i.Descripcion, 'description': i.Valor, 'value': i.idUnidadNegocioLM} } );    
        }
      },
      error: (err) => {
        if(err.status == 401){
          this.toastr.error('Tu sesión expiró o no tienes permiso para ver esta página.', 'Acceso no autorizado');
          this.router.navigate(['/login']);
        }else{
          //validacion cuando la lista esta vacia
          this.unidadNegocio = [];
          this.activoRQ.idUnidadNegocioLM = ""; 
          if(err.error){
            let { ClassInfo } = err.error;
            this.toastr.error(ClassInfo ? ClassInfo.Error : 'Comprueba tu conexión a internet.' , 'Error');
          }
        }
        console.log(err);
      }
    });
  }

  getItemSelected(lista: any[], itemSelected: string){
    if(lista != null){
      return lista.find(x => x['value'] == itemSelected)['label'];
    }
    return '';
  }

  getItemDescriptionSelected(lista: any[], itemSelected: string){
    if(lista != null){
      return lista.find(x => x['value'] == itemSelected)['description'];
    }
    return '';
  }

  getChangeCCDebito(event: any, lista: any[], posicion: number){
    //Nueva cuentaContable ['CIA','CC','UB','CTA','SCTA','EQ','IC']
    let defaults = ['??', '??','??????','????','????','?????','??']
    
    let arrayCuenta = this.cuentaContableDebito.split('-');
    if(lista != null){
      let selected = lista.find( x => x['value'] == event.value)['description'] != null ?  lista.find( x => x['value'] == event.value)['description'] : null;
      if(selected != null){
        arrayCuenta[posicion] = ` ${selected} `;
      }else{
        arrayCuenta[posicion] = ` ${defaults[posicion]} `;
      }
    }else{
      arrayCuenta[posicion] = ` ${defaults[posicion]} `;
    }

    let newCredito = '';
    arrayCuenta.forEach( (item,index) => {
      newCredito = `${newCredito}${item}`;
      if(index <= (arrayCuenta.length-2)) newCredito = `${newCredito}-`;
    });
    this.cuentaContableDebito = newCredito;
  }

  //#endregion
}
